module.exports = __webpack_public_path__ + "img/sam5.027c43fc.jpg";